/** Workspace URL validation for central login and mistaken login input. */

const KNOWN_TLDS = new Set([
  "com", "org", "net", "io", "app", "ai", "co", "uk", "dev", "us", "in", "eu",
  "me", "info", "biz", "tech", "cloud", "online", "site",
]);

export function normalizeWorkspaceHost(raw) {
  return String(raw || "")
    .trim()
    .replace(/^https?:\/\//i, "")
    .replace(/\/.*$/, "")
    .replace(/:\d+$/, "");
}

export function looksLikeWorkspaceUrl(input) {
  const v = String(input || "").trim();
  if (!v || v.includes("@")) return false;
  if (/^https?:\/\//i.test(v)) return true;
  return /^[a-z0-9][a-z0-9.-]*$/i.test(v);
}

export function validateWorkspaceUrl(raw) {
  const host = normalizeWorkspaceHost(raw);
  if (!host) {
    return { ok: false, message: "Enter your workspace URL (e.g. your-company.sellix.app)" };
  }
  const parts = host.split(".").filter(Boolean);
  if (parts.length < 2) {
    return {
      ok: false,
      message: "Workspace URL must include a domain extension (e.g. .com, .app, or .io). Example: your-company.sellix.app",
    };
  }
  const tld = parts[parts.length - 1].toLowerCase();
  if (!/^[a-z]{2,63}$/.test(tld)) {
    return {
      ok: false,
      message: "Workspace URL must include a valid top-level domain (e.g. .com, .app, or .io).",
    };
  }
  if (!KNOWN_TLDS.has(tld) && parts.length < 3) {
    return {
      ok: false,
      message: "Workspace URL must include a valid top-level domain (e.g. .com, .app, or .io). Example: your-company.sellix.app",
    };
  }
  return { ok: true, value: host.toLowerCase() };
}

export function isCentralLoginHost(hostname = globalThis.location?.hostname || "") {
  const host = String(hostname || "").toLowerCase();
  if (!host) return false;
  if (process.env.REACT_APP_CENTRAL_LOGIN === "true") return true;
  if (host === "sellix.app" || host === "www.sellix.app") return true;
  return host.startsWith("login.") || host.startsWith("app.");
}
